module.exports = __webpack_public_path__ + "static/media/radio-light.f1afe726.svg";